export class PropertyDefinition {
    // code depends on some properties being undefined.
    // keep this a getter -> old code used to just have 1 type only, so leave
    // this getter to keep the old code working
    get type() {
        return this.types?.[0];
    }
    set type(val) {
        this.types = val ? [val] : undefined;
    }
    // helper to check if types length > 0
    get compoundType() {
        return this.types !== undefined && this.types.length > 1;
    }
    get hasJsonProperty() {
        return this.serializedName !== this.originalName;
    }
    constructor(serializedName) {
        this.array = false;
        this.set = false;
        this.readonly = false;
        this.writeonly = false;
        this.originalName = serializedName;
        this.serializedName = serializedName;
    }
}
//# sourceMappingURL=property-definition.js.map